import styled from "styled-components";

export const noReq = styled.div`
    text-align: center;
    padding: 100px 0;
    margin: 0 auto;
    width: ${p => p.width ? p.width : '400px'};
`;
export const Icon = styled.img`
    width: 168px;
    margin-bottom: 48px;
`;
export const Heading = styled.h4`
    font-size: 22px;
    line-height: 28px;
    font-weight: 900;
    color: #000000;
    margin-bottom: 12px;
`;
export const Description = styled.p`
    font-size: 16px;
    line-height: 24px;
    color: #4A4A4A;
    margin-bottom: 32px;
    span{
        font-weight: 700;
    }
`;
export const Cta = styled.button`
    display: inline-flex;
    height: 44px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    font-family: 'Lato';
    font-weight: 900;
    cursor: pointer;
    outline: 0;
    border: 0;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
    border-radius: 4px;
    background-color: #008CFF;
    margin-left: 13px;
    padding: 0 45px;
    flex-shrink: 0;
    text-transform: uppercase;
`;